import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import { HttpHeaders, HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
const BASE_URL = env.apiConfig.baseUrl;
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  BASE_URL: string;
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  constructor(private _httpClient: HttpClient) { }
  public get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this._httpClient.get(BASE_URL + path, { params }).pipe(catchError(this.formatErrors));
  }

  public getExternalUrl(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this._httpClient.get(path, { params }).pipe(catchError(this.formatErrors));
  }

  public put(path: string, body: object = {}): Observable<any> {
    return this._httpClient
      .put(BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public post(path: string, body: object = {}): Observable<any> {
    return this._httpClient
      .post(BASE_URL + path, JSON.stringify(body), this.options)
      .pipe(catchError(this.formatErrors));
  }

  public delete(path: string): Observable<any> {
    return this._httpClient.delete(BASE_URL + path).pipe(catchError(this.formatErrors));
  }


  public uploadFile(path: string, formData: any, isPost: boolean = true): Observable<any> {
    const req = new HttpRequest(
      isPost ? 'POST' : 'PUT', BASE_URL + path, formData, {
      reportProgress: true //This is required for track upload process
    });
    return this._httpClient.request(req);
  }

  public downloadFile(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this._httpClient.get(BASE_URL + path, { responseType: 'blob' })
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }
}
